/**************************************************************************************************/
/** @import Node Packages                                                                        **/
/**************************************************************************************************/
import { defineComponent } from 'vue'

/**************************************************************************************************/
/** @import Constants                                                                            **/
/**************************************************************************************************/
import { AppValues } from '@/Constants/AppValues'

/**************************************************************************************************/
/** @import Mixins                                                                               **/
/**************************************************************************************************/
import MixinComponent from '@/Mixins/MixinComponent'
import MixinResponsive from '@/Mixins/MixinResponsive'

/**************************************************************************************************/
/** @internal Const @name AddonForm                                                              **/
/**************************************************************************************************/
const AddonForm = defineComponent(
{
	/*************************************************/
	/** @Properties                                 **/
	/*************************************************/
	name: 'AddonForm', mixins: [MixinComponent, MixinResponsive],

	props:
	{
		show: Boolean
	},

	/*************************************************/
	/** @Data                                       **/
	/*************************************************/
	data()
	{
		return {
			states:
			{
				addonCode: '',
				addonName: '',
				groupArticle: null,
				isForClient: false,
				typeEquipment: null
			}
		}
	},

	/*************************************************/
	/** @Computed                                   **/
	/*************************************************/
	computed:
	{
		GetEquipmentTypes() : Array<any>
		{
			return Object.values(AppValues.EquipmentTypes).sort()
		},

		GetGroupArticles() : Array<any>
		{
			return Object.values(AppValues.ArticleGroups).sort()
		},

		GetIsForClientText() : string
		{
			return this.states.isForClient ? 'Sí' : 'No'
		}
	},

	/*************************************************/
	/** @Methods                                    **/
	/*************************************************/
	methods:
	{
		Clear() : void
		{
			this.states =
			{
				addonCode: '',
				addonName: '',
				groupArticle: null,
				isForClient: false,
				typeEquipment: null
			}
		}
	}
})

/**************************************************************************************************/
/** @export Component @name AddonForm                                                            **/
/**************************************************************************************************/
export default AddonForm

/**************************************************************************************************/
/** @export Type @name AddonFormRef                                                              **/
/**************************************************************************************************/
export type AddonFormRef = InstanceType<typeof AddonForm>